/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I lose or gain weight?`)
};

const es_bmr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo pierdo o gano peso?`)
};

const de_bmr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie nehme ich ab oder zu?`)
};

const nl_bmr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe val ik af of kom ik aan?`)
};

const fr_bmr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment perdre ou prendre du poids ?`)
};

const it_bmr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come faccio a dimagrire o ad aumentare di peso?`)
};

const pt_br2_bmr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como faço para emagrecer ou ganhar peso?`)
};

const pt_bmr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como perco ou ganho peso?`)
};

const ja_bmr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どうすれば体重を減らしたり増やしたりできますか?`)
};

const zh_bmr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我该如何减重或增重？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq_q4", locale)
	if (locale === "en") return en_bmr_faq_q4(inputs)
	if (locale === "es") return es_bmr_faq_q4(inputs)
	if (locale === "de") return de_bmr_faq_q4(inputs)
	if (locale === "nl") return nl_bmr_faq_q4(inputs)
	if (locale === "fr") return fr_bmr_faq_q4(inputs)
	if (locale === "it") return it_bmr_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq_q4(inputs)
	if (locale === "pt") return pt_bmr_faq_q4(inputs)
	if (locale === "ja") return ja_bmr_faq_q4(inputs)
	return zh_bmr_faq_q4(inputs)
};